import { Form } from './../utils';
import * as VueGoogleMaps from 'vue2-google-maps';
import VueHighlightJS from 'vue-highlightjs';
import { ClientTable, ServerTable, Event } from 'vue-tables-2';
import ToggleButton from 'vue-js-toggle-button';
import moment from 'moment-timezone';
import Multiselect from 'vue-multiselect';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import Vue from "vue";
import VCalendar from 'v-calendar';

require('./../spark-components/bootstrap');

Vue.use(ClientTable, {
    theme: 'bootstrap4',
    skin: 'table table-striped',
    sortIcon: { base: 'fa mt-1', up: 'fa-sort-up', down: 'fa-sort-down', is: 'fa-sort' }
});
Vue.use(ServerTable, {
    theme: 'bootstrap4',
    skin: 'table table-striped',
    sortIcon: { base: 'fa mt-1', up: 'fa-sort-up', down: 'fa-sort-down', is: 'fa-sort' }
});
Vue.use(VueGoogleMaps, {
    load: {
        key: DevSquad.mapsId,
        libraries: 'places',
    },
    installComponents: true,
});
Vue.use(VueHighlightJS);
Vue.use(ToggleButton);
Vue.component('multiselect', Multiselect);
Vue.use(VCalendar);

window.moment = moment;
window.Form = Form;

require('./home');
require('./shared');
require('./locations');
require('./invites');
require('./contacts');
require('./reviews');
require('./campaigns');
require('./metrics');
require('./dashboards');
require('./kiosk');
require('./plans');
require('./leaderboards');
require('./messenger');
require('./reports');
require('./webchat');
